import { type ReactNode } from 'react';
import { useEditor, EditorContent } from '@tiptap/react';
import { buildExtensions } from './tiptap-editor-config';
import { TiptapToolbar } from './tiptap-toolbar';

type Props = {
  initialHtml: string;
  initialJson: unknown;
  onChange: (html: string, json: unknown) => void;
  placeholder?: string;
};

const SHELL =
  'overflow-hidden rounded-lg border border-white/[0.06] bg-surface focus-within:border-brand-red/40';
const PROSE =
  'min-h-[280px] px-md py-sm text-[15px] leading-relaxed text-text-primary outline-none [&_*]:outline-none [&_p.is-editor-empty:first-child]:before:pointer-events-none [&_p.is-editor-empty:first-child]:before:float-left [&_p.is-editor-empty:first-child]:before:h-0 [&_p.is-editor-empty:first-child]:before:text-text-tertiary [&_p.is-editor-empty:first-child]:before:content-[attr(data-placeholder)]';

export function TiptapEditor({
  initialHtml,
  initialJson,
  onChange,
  placeholder = 'Escribe tu comunicado…',
}: Props): ReactNode {
  const editor = useEditor({
    extensions: buildExtensions(placeholder),
    content: initialJson || initialHtml || '',
    onUpdate: ({ editor: ed }) => onChange(ed.getHTML(), ed.getJSON()),
  });
  return (
    <div className={SHELL}>
      <TiptapToolbar editor={editor} />
      <EditorContent editor={editor} className={PROSE} />
    </div>
  );
}
